import { render, staticRenderFns } from "./virtualCurrency.vue?vue&type=template&id=b8a5daa8&scoped=true"
import script from "./virtualCurrency.vue?vue&type=script&lang=js"
export * from "./virtualCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5daa8",
  null
  
)

export default component.exports